"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichContentHeading = void 0;
const react_1 = __importDefault(require("react"));
const RichContentHeading = ({ children, color }) => {
    if (!(children === null || children === void 0 ? void 0 : children.content) || !children.content.text) {
        return null;
    }
    switch (children.level) {
        case 1:
            return (react_1.default.createElement("h1", { color: color, "data-cy": "heading1" }, children.content.text));
        case 2:
            return (react_1.default.createElement("h2", { color: color, "data-cy": "heading2" }, children.content.text));
        case 3:
            return (react_1.default.createElement("h3", { color: color, "data-cy": "heading3" }, children.content.text));
        case 4:
            return (react_1.default.createElement("h4", { color: color, "data-cy": "heading4" }, children.content.text));
        case 5:
            return (react_1.default.createElement("h5", { color: color, "data-cy": "heading5" }, children.content.text));
        case 6:
        default:
            return (react_1.default.createElement("h6", { color: color, "data-cy": "heading6" }, children.content.text));
    }
};
exports.RichContentHeading = RichContentHeading;
